import {
  ItManagementGetSoftwareSetupsDocument,
  ItManagementUpdateSoftwareSetupDocument,
  ItManagementUpdateSoftwareSetupMutation,
  ItManagementUpdateSoftwareSetupMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateSoftwareSetup = () => {
  const [updateSoftwareSetup, { loading }] = useMutation(ItManagementUpdateSoftwareSetupDocument, {
    extractorFn: (data: ItManagementUpdateSoftwareSetupMutation) =>
      data.itManagementMutations.updateItmanagementSoftwareSetup,
  })

  return {
    updateSoftwareSetup(
      variables: ItManagementUpdateSoftwareSetupMutationVariables,
      companyId: number
    ) {
      return updateSoftwareSetup({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: ItManagementGetSoftwareSetupsDocument,
            variables: { ids: [variables.id], companyId: companyId },
          },
        ],
      })
    },
    loading,
  }
}
